import { styled } from '../../../utils/styled';
import { propStyles } from '../../../utils/propStyles';

export const Sup = styled<any, any>('sup', 'sup', 'superscript')`
    ${propStyles};
`;



// WEBPACK FOOTER //
// ./src/Components/Superscript/StyledComponents/Sup.tsx